
const fv__slider = new Swiper(".fv__slider", {
  slidesPerView: 1,
  loop: true,
  centeredSlides: true,
  speed: 2000,
  autoplay: {
    delay: 5000, // 3秒ごとに自動スライド
    disableOnInteraction: false, // ユーザーが操作しても自動再生を継続
  },
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  pagination: {
    el: ".swiper-pagination", // ページネーションのクラス名を指定
    clickable: true
  },
  breakpoints: {
    768: {
      slidesPerView: 1,
    },
  },
});

const campaign = new Swiper(".campaign__slider", {
  slidesPerView: 1,
  loop: true,
  speed: 500,
  spaceBetween: 60,
  pagination: {
    el: ".swiper-pagination", // ページネーションのクラス名を指定
    clickable: true
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
  },
});
